import { useSsrAdapter as a } from "./highrise668.mjs";
import { inject as d, onBeforeMount as f } from "vue";
import u from "./highrise1439.mjs";
import { configProviderInjectionKey as m } from "./highrise690.mjs";
import { cssrAnchorMetaName as s } from "./highrise1359.mjs";
import { throwError as p } from "./highrise676.mjs";
function M(t, i, l) {
  if (!i) {
    process.env.NODE_ENV !== "production" && p("use-style", "No style is specified.");
    return;
  }
  const r = a(), e = d(m, null), n = () => {
    const o = l.value;
    i.mount({
      id: o === void 0 ? t : o + t,
      head: !0,
      anchorMetaName: s,
      props: {
        bPrefix: o ? `.${o}-` : void 0
      },
      ssr: r,
      parent: e == null ? void 0 : e.styleMountTarget
    }), e != null && e.preflightStyleDisabled || u.mount({
      id: "n-global",
      head: !0,
      anchorMetaName: s,
      ssr: r,
      parent: e == null ? void 0 : e.styleMountTarget
    });
  };
  r ? n() : f(n);
}
export {
  M as default
};
